import React, { useState, useId, isValidElement, cloneElement } from 'react';
import useTheme from 'branding/theme';
const ARROW_SIZE = 10;
const TOOLTIP_GAP = '0.8rem';
const Tooltip = ({ content, placement = 'bottom-left', width, children, className, styles, id }) => {
    const [visible, setVisible] = useState(false);
    const tooltipId = useId();
    const { colors, borders, typography } = useTheme();
    const tooltipPlacement = {
        'top-left': { bottom: '100%', left: 0, marginBottom: TOOLTIP_GAP },
        'top-right': { bottom: '100%', right: 0, marginBottom: TOOLTIP_GAP },
        'bottom-left': { top: '100%', left: 0, marginTop: TOOLTIP_GAP },
        'bottom-right': { top: '100%', right: 0, marginTop: TOOLTIP_GAP },
        left: {
            right: '100%',
            top: '50%',
            transform: 'translateY(-50%)',
            marginRight: TOOLTIP_GAP
        },
        right: {
            left: '100%',
            top: '50%',
            transform: 'translateY(-50%)',
            marginLeft: TOOLTIP_GAP
        }
    };
    const arrowPlacement = {
        'top-left': {
            bottom: -ARROW_SIZE / 2,
            left: '1.6rem',
            borderRight: `1px solid ${colors.neutrals.borderBeta}`,
            borderBottom: `1px solid ${colors.neutrals.borderBeta}`
        },
        'top-right': {
            bottom: -ARROW_SIZE / 2,
            right: '1.6rem',
            borderRight: `1px solid ${colors.neutrals.borderBeta}`,
            borderBottom: `1px solid ${colors.neutrals.borderBeta}`
        },
        'bottom-left': {
            top: -ARROW_SIZE / 2,
            left: '1.6rem',
            borderTop: `1px solid ${colors.neutrals.borderBeta}`,
            borderLeft: `1px solid ${colors.neutrals.borderBeta}`
        },
        'bottom-right': {
            top: -ARROW_SIZE / 2,
            right: '1.6rem',
            borderTop: `1px solid ${colors.neutrals.borderBeta}`,
            borderLeft: `1px solid ${colors.neutrals.borderBeta}`
        },
        left: {
            right: -ARROW_SIZE / 2,
            top: '50%',
            marginTop: -ARROW_SIZE / 2,
            borderTop: `1px solid ${colors.neutrals.borderBeta}`,
            borderRight: `1px solid ${colors.neutrals.borderBeta}`
        },
        right: {
            left: -ARROW_SIZE / 2,
            top: '50%',
            marginTop: -ARROW_SIZE / 2,
            borderLeft: `1px solid ${colors.neutrals.borderBeta}`,
            borderBottom: `1px solid ${colors.neutrals.borderBeta}`
        }
    };
    const tooltipStyles = {
        position: 'absolute',
        zIndex: 3,
        minWidth: '18rem',
        maxWidth: '26rem',
        ...(width !== undefined && { width, maxWidth: width }),
        padding: '0.8rem 1rem',
        ...typography.paragraph.small,
        fontWeight: 400,
        letterSpacing: 'normal',
        textTransform: 'none',
        lineHeight: 1.5,
        textAlign: 'left',
        color: colors.neutrals.textAlpha,
        background: colors.neutrals.background,
        border: `1px solid ${colors.neutrals.borderBeta}`,
        ...borders.shape.rounded,
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.14)',
        whiteSpace: 'pre-line',
        opacity: visible ? 1 : 0,
        visibility: visible ? 'visible' : 'hidden',
        pointerEvents: 'none',
        transition: visible
            ? 'opacity 0.18s ease-out, visibility 0s linear 0s'
            : 'opacity 0.18s ease-out, visibility 0s linear 0.18s',
        ...tooltipPlacement[placement]
    };
    const arrowStyles = {
        position: 'absolute',
        width: ARROW_SIZE,
        height: ARROW_SIZE,
        background: colors.neutrals.background,
        transform: 'rotate(45deg)',
        ...arrowPlacement[placement]
    };
    const anchorStyles = {
        position: 'relative',
        display: 'inline-flex'
    };
    let trigger = children;
    if (isValidElement(children)) {
        const childEl = children;
        const existing = childEl.props['aria-describedby'];
        trigger = cloneElement(childEl, {
            'aria-describedby': existing ? `${existing} ${tooltipId}` : tooltipId
        });
    }
    return (React.createElement("span", { id: id, className: className, style: styles, onMouseEnter: () => setVisible(true), onMouseLeave: () => setVisible(false), onFocus: () => setVisible(true), onBlur: () => setVisible(false) },
        React.createElement("span", { style: anchorStyles },
            trigger,
            React.createElement("span", { id: tooltipId, role: "tooltip", style: tooltipStyles },
                React.createElement("span", { "aria-hidden": "true", style: arrowStyles }),
                content))));
};
export default Tooltip;
//# sourceMappingURL=index.js.map